// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__1vwov","inner":"Modal_inner__DUIkk","open":"Modal_open__Lq59n","close":"Modal_close__2EfR5"};